import { useContext } from "@nuxtjs/composition-api";
import getPricesQuery from "./getPricesQuery.gql";
const usePrice = () => {
  const { app } = useContext();
  const isCached = !app.$wm.catalog.priceMatrixEnabled;
  const getPrices = async (variables) => {
    var _a;
    const { data } = await app.$vsf.$magento.api.customQuery({ query: getPricesQuery, queryVariables: variables, cache: isCached, authorize: true });
    return (_a = data == null ? void 0 : data.products) != null ? _a : { items: [] };
  };
  const getPricesBySku = async (skus, pageSize = 20, currentPage = 1) => getPrices(
    { filter: { sku: { in: skus } }, pageSize, currentPage }
  );
  return { getPricesBySku, getPrices };
};
export {
  usePrice
};
